import { render, staticRenderFns } from "./modal-product-combination.vue?vue&type=template&id=31f91e2f&scoped=true"
import script from "./modal-product-combination.vue?vue&type=script&lang=js"
export * from "./modal-product-combination.vue?vue&type=script&lang=js"
import style0 from "./modal-product-combination.vue?vue&type=style&index=0&id=31f91e2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f91e2f",
  null
  
)

export default component.exports